import React from 'react';
import './DeletePostModal.css';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { DeletePostModalIcon } from '../icons/Icons';

const DeletePostModal = ({ modal, toggle, onAccept }) => {
    return (
        <div>
            <Modal isOpen={modal} toggle={toggle} className={`delete-post-modal`}>
                <ModalHeader toggle={toggle} />
                <ModalBody>
                    <DeletePostModalIcon />
                    Are you sure you want to delete your post?
                </ModalBody>
                <ModalFooter>
                    <Button outline className="w-25" color="primary" onClick={toggle}>
                        No
                    </Button>{' '}
                    <Button
                        outline
                        className="w-25"
                        color="primary"
                        onClick={() => {
                            onAccept(true);
                            toggle();
                        }}
                    >
                        Yes
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default DeletePostModal;
